// extracted by mini-css-extract-plugin
export default {"buttonSection":"ViewApplication_buttonSection__3rK3B","publishButton":"ViewApplication_publishButton__awetp","closeButton":"ViewApplication_closeButton__-S51Y"};